// src/components/anlagen/AnlagenTable.jsx
import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { useColorModeValue } from "../ui/color-mode";
import AnlagenRow from "./AnlagenRow";

export default function AnlagenTable({ anlagen, user, onDelete, onUpdate, onView, onEdit, }) {
  // Color tokens by mode
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.300");
  const headerBg = useColorModeValue("blue.50", "whiteAlpha.100");
  const headerColor = useColorModeValue("blue.700", "blue.200");
  const textMuted = useColorModeValue("gray.500", "gray.400");

  const headers = ["Projekt-Nr.", "Name", "Ort", "Größe (kWp)", "Aktionen"];
  const rows = Array.isArray(anlagen) ? anlagen : [];

  return (
    <Box
      bg={cardBg}
      borderWidth="1px"
      borderColor={borderColor}
      boxShadow="md"
      borderRadius="xl"
      overflow="hidden"
    >
      <Box overflowX="auto">
        <Box as="table" w="100%" borderCollapse="separate" borderSpacing="0">
          <Box as="thead" bg={headerBg}>
            <Box as="tr">
              {headers.map((title) => (
                <Box
                  as="th"
                  key={title}
                  textAlign="left"
                  fontSize="xs"
                  fontWeight="semibold"
                  color={headerColor}
                  textTransform="uppercase"
                  letterSpacing="0.08em"
                  whiteSpace="nowrap"
                  px="12px"
                  py="10px"
                  borderBottom="1px solid"
                  borderColor={borderColor}
                >
                  {title}
                </Box>
              ))}
            </Box>
          </Box>

          <Box as="tbody">
            {rows.length > 0 ? (
              rows.map((anlage, idx) => {
                const key = anlage?.id ?? `row-${idx}`;
                return (
                  <AnlagenRow
                    key={key}
                    anlage={anlage || {}}
                    user={user}
                    onDelete={onDelete}
                    onUpdate={onUpdate}
                    onView={onView}
                    onEdit={onEdit}
                  />
                );
              })
            ) : (
              <Box as="tr">
                <Box
                  as="td"
                  colSpan={headers.length}
                  px="12px"
                  py="16px"
                  textAlign="center"
                  borderBottom="1px solid"
                  borderColor={borderColor}
                >
                  <Text color={textMuted} fontStyle="italic">
                    Keine Anlagen gefunden
                  </Text>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}  